import { withStyles } from '@mui/styles';
import ItemTable from './ItemTable';
import styles from './styles';

export default withStyles(styles)(ItemTable);
